/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <b-modal
    v-model="show"
    id="quick-modal"
    size="xl"
    scrollable
    no-fade
    modal-class="bcm-modal qw-modal slide-up modal-fullscreen"
    :hide-footer="true"
    @hidden="resetModal"
    :no-close-on-backdrop="noCloseOnBackdrop"
    ref="modal"
  >
    <template #modal-header="{ close }">
      <right-block-nav @clicked="close()">
        <template #end>
          <button class="btn btn-icon btn-icon-border-black icon-rounded nav-item" @click="close()">
            <svg class="o-icon"><use xlink:href="#close"></use></svg>
          </button>
        </template>
      </right-block-nav>
    </template>
    <component :is="productLayout" :productUrlKey="quickProductUrlKey" @added-to-cart="closeModal"></component>
  </b-modal>
</template>

<script>
import { EventBus } from '@/helpers'
import RightBlockNav from 'theme/components/Header/RightBlock/RightBlockNav'
import QuickClassicProduct from 'theme/components/QuickView/QuickClassicProduct.vue'

export default {
  data () {
    return {
      notifyProcess: false,
      variantSelected: undefined,
      noCloseOnBackdrop: false
    }
  },
  computed: {
    productLayout () {
      return 'QuickClassicProduct'
    },
    quickProductUrlKey () {
      return this.$store.state.quickBuy.productUrlKey
    },
    show: {
      get () {
        return !!this.$store.state.quickBuy.toggleQuickBuy
      },
      set (newValue) {
        this.$store.commit('quickBuy/setToggle', newValue)
        this.$store.commit('quickBuy/setCurrentProductUrlKey', '')
      }
    }
  },
  methods: {
    toggleBackdrop (payload) {
      if (!payload) {
        // wait 300 ms to prevento closing quick view if select go outside dialog
        setTimeout(() => {
          this.noCloseOnBackdrop = payload
        }, 300)
      } else {
        this.noCloseOnBackdrop = payload
      }
      return this.noCloseOnBackdrop
    },
    closeModal () {
      return this.$store.commit('quickBuy/setToggle', null)
    },
    resetModal () {
      this.show = false
    }
  },
  mounted () {
    EventBus.$on('sizeSelector:toggled', this.toggleBackdrop)
  },
  destroyed () {
    EventBus.$off('sizeSelector:toggled', this.toggleBackdrop)
  },
  components: {
    RightBlockNav,
    QuickClassicProduct
  }
}
</script>
